import { createDataContext } from './Context';
import { UserViolation, ViolationQueryParams } from '../types/Violation';
import { getDateRangeError } from '../utils/dateRange';

const parseResponse = (response: unknown): UserViolation[] => {
  if (!Array.isArray(response) || response.some(row =>
    !row || typeof row !== 'object' || Array.isArray(row) ||
    Object.values(row).some(value => value !== null && !['string', 'number', 'boolean'].includes(typeof value))
  )) {
    throw new Error('Invalid violations response');
  }
  return response;
};

export const { useDataContext: useViolationContext, DataProvider: ViolationProvider } = createDataContext<UserViolation, ViolationQueryParams>(
  'tripQueryAPI',
  '/users/v1/getviolations',
  parseResponse,
  {
    validateQueryParams: (value: unknown): value is ViolationQueryParams => {
      if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
      const query = value as ViolationQueryParams;
      return typeof query.startDate === 'string' && typeof query.endDate === 'string' &&
        getDateRangeError(query.startDate, query.endDate) === null;
    },
  }
);
